import axios from "axios";

const instance = axios.create({
  // Prod : REACT_APP_API_URL=https://api.jm-interim.com (voir .env.production),
  // ce qui permet de fermer le port 3000. Fallback = ancien comportement.
  baseURL: "https://admin.jm-interim.com:3000",
});

instance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

/* instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      // Handle 403 Forbidden error by redirecting to the login page
      // Replace '/login' with the actual login page URL
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
); */

export default instance;
